import { InfiniteData } from '@tanstack/react-query';
import { useEffect, useMemo } from 'react';
import { AppTabularDto } from '../dtos/app-tabular.dto';
import { DataTablePaginatedComponentProps } from './data-table-basic.interface';
import { DataTableFlatComponent } from './data-table-flat.component';

export interface DataTableComponentProps
  extends DataTablePaginatedComponentProps {
  data: InfiniteData<AppTabularDto<any>, unknown> | undefined;
}

const defRows: any[] = [];
/**
 * This component is able to handle paginated data.
 */
export const DataTableComponent = ({
  onRowSelectionChange,
  enableRowSelection = false,
  enableMultiRowSelection,
  height,
  parseMeasuresColumns,
  parseColumns,
  startColumns,
  endColumns,
  showTotal = false,
  onFlatData,
  className,
  idField,
  data,
  totalData,
  isFetching,
  isFetchingNextPage,
  hasNextPage,
  fetchNextPage,
  setSortBy,
  sortBy,
  enableStickyFirstColumn = false,
  suppressRowClickSelection,
  expandRows,
}: DataTableComponentProps) => {
  // flat pages
  const flatPagesData: AppTabularDto<any> | undefined = useMemo(() => {
    if (!data?.pages) {
      return undefined;
    }
    const rows = data?.pages?.flatMap((page) => page.rows.concat());
    const firstPage = data?.pages[0];
    return { ...firstPage, rows };
  }, [data?.pages]);
  //we must flatten the array of arrays from the useInfiniteQuery hook
  const flatData = useMemo(
    () => flatPagesData?.rows ?? defRows,
    [flatPagesData],
  );
  useEffect(() => {
    if (onFlatData) {
      onFlatData(flatData);
    }
  }, [onFlatData, flatData]);
  return (
    <DataTableFlatComponent
      onRowSelectionChange={onRowSelectionChange}
      enableRowSelection={enableRowSelection}
      enableMultiRowSelection={enableMultiRowSelection}
      height={height}
      parseMeasuresColumns={parseMeasuresColumns}
      parseColumns={parseColumns}
      startColumns={startColumns}
      endColumns={endColumns}
      showTotal={showTotal}
      className={className}
      idField={idField}
      data={flatPagesData}
      totalData={totalData}
      isFetching={isFetching}
      isFetchingNextPage={isFetchingNextPage}
      hasNextPage={hasNextPage}
      fetchNextPage={fetchNextPage}
      setSortBy={setSortBy}
      sortBy={sortBy}
      enableStickyFirstColumn={enableStickyFirstColumn}
      suppressRowClickSelection={suppressRowClickSelection}
      expandRows={expandRows}
    />
  );
};
